import script from "./fw14_categories.vue?vue&type=script&setup=true&lang=js"
export * from "./fw14_categories.vue?vue&type=script&setup=true&lang=js"

import "./fw14_categories.vue?vue&type=style&index=0&id=87748d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87748d72"]])

export default __exports__